/* eslint-disable max-len */
import { createSlice } from "@reduxjs/toolkit";


const initialState = {
    globalVariables:[],
    vitalInfo:[],
    filterState:[],
    restrict:false,
}

  
// export const GetCommonData = createAsyncThunk('commondata', async (id) =>  handlefetch(id))

            
const SystemConfigSlice = createSlice({

    name: 'SystemConfig',
    initialState,
    reducers: {
        handleSystemConfig:(state,action)=>{
            state.globalVariables=action?.payload?.global_variables
            state.vitalInfo=action.payload?.vital_information
        },
      
        resetState:(state)=>{
            state.globalVariables=[]
            state.vitalInfo=[]
            state.restrict=false
           
        },
        handleAddFilterValues:(state,action)=>{
            state.filterState=action.payload
        },
        resetFilterState:(state)=>{
            state.filterState=[]
        },
        handleRestrictKey:(state,action)=>{
            state.restrict=action.payload
        },
    
        
        

    },
   
})
export const {handleRestrictKey,handleLocationKey,handleIsUserScreen,handleIsViewScreen,handleSystemConfig,resetState,handleAddFilterValues,resetFilterState,handleViewUserScreen } = SystemConfigSlice.actions;
export default SystemConfigSlice.reducer